import React from 'react';
import ViewComponent from '../core/ViewComponent';
export default class Mask extends ViewComponent {
    render() {
        return React.createElement("div", Object.assign({}, this.getMergedProps()));
    }
}
Mask.displayName = 'Mask';
Mask.defaultProps = {
    suffixCls: 'mask',
};
